import React from 'react';
import { FaUser, FaCheck } from 'react-icons/fa';
import { HiStar } from 'react-icons/hi';
import { clearRegistrationUser } from 'utils/fns';
import { participantesVisiveis } from 'utils/participantes-validacao';

interface Participante {
  nome: string;
  matricula: string;
  displayName?: string;
  confirmado: boolean;
  valido?: boolean;
}

interface IniciativaParticipantesProps {
  participantes: Participante[];
  rankingMap?: Map<string, { points: number; posicao: number }>;
  totalValidos?: number;
  totalOriginal?: number;
  validadeApurada?: boolean;
}

export const IniciativaParticipantes: React.FC<IniciativaParticipantesProps> = ({
  participantes,
  rankingMap,
  totalValidos,
  totalOriginal,
  validadeApurada,
}) => {
  const { lista: visiveis, numerador: confirmados, denominador: total } = participantesVisiveis(
    participantes,
    { ativo: true, validadeApurada, totalValidos, totalOriginal }
  );

  const getRanking = (matricula: string) =>
    rankingMap?.get(clearRegistrationUser(matricula));

  const sorted = [...visiveis].sort((a, b) => {
    if (rankingMap) {
      const rA = getRanking(a.matricula)?.posicao ?? Number.MAX_SAFE_INTEGER;
      const rB = getRanking(b.matricula)?.posicao ?? Number.MAX_SAFE_INTEGER;
      if (rA !== rB) return rA - rB;
    }
    return (a.displayName || a.nome).localeCompare(b.displayName || b.nome);
  });

  return (
    <div className="bg-white border border-gray-200 rounded-xl p-5">
      <h3 className="text-sm font-bold text-[#1e3a5f] mt-0 mb-4">
        Participantes da realização ({confirmados} de {total} confirmados)
      </h3>
      <div className="grid grid-cols-3 gap-3 sm:grid-cols-2">
        {sorted.map((participante, index) => {
          const ranking = getRanking(participante.matricula);
          return (
            <div
              key={index}
              className={`rounded-lg p-2.5 ${
                participante.confirmado
                  ? 'bg-green-50 border border-green-200'
                  : 'bg-gray-50 border border-gray-200'
              }`}
            >
              <div className="flex items-start gap-2">
                <FaUser className={`${participante.confirmado ? 'text-green-700' : 'text-gray-400'} shrink-0 mt-0.5`} size={16} />
                {participante.confirmado && (
                  <FaCheck className="text-green-700 shrink-0 mt-0.5" size={13} />
                )}
                <div className="flex flex-col gap-1 min-w-0">
                  <span className="text-xs text-gray-700 leading-snug">
                    {participante.displayName || `${participante.nome} (${participante.matricula})`}
                  </span>
                  {ranking && (
                    <span className="inline-flex items-center gap-1 text-[11px] font-extrabold text-blue-bb-1 bg-yellow-bb-1 rounded-full px-2 py-0.5 self-start">
                      <HiStar size={11} />
                      #{ranking.posicao} · {ranking.points.toFixed(1)} pts
                    </span>
                  )}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
